import React from "react";
import { Outlet } from "react-router-dom";
import Styles from "./AuthLayout.module.css";

function AuthLayout() {
  return (
    <div className={Styles.bgContainer + " container-fluid"}>
      <div className={Styles.leftBg}></div>
      <div className={Styles.rightBg}></div>
      <div className={Styles.bottomLeft}></div>
      <div className={Styles.bottomRight}></div>
      <div className={Styles.bg}></div>
      <div className={Styles.loginContainer}>
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
